export interface BrandDataModel {
    brandName: string;
    fakeBrand?: boolean;
}

export function shuffleBrands(brandData: readonly BrandDataModel[] | undefined): string[] {
    const names = brandData?.map((b) => b.brandName) ?? [];
    const shuffled = [...names];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
}